/* tslint:disable */
/* eslint-disable */
/**
 * wicky_ups
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../Components/api/runtime';
/**
 * 
 * @export
 * @interface UserPreData
 */
export interface UserPreData {
    /**
     * 
     * @type {string}
     * @memberof UserPreData
     */
    id: string;
    /**
     * ワンタイムパスワード�E共通鍵
     * @type {string}
     * @memberof UserPreData
     */
    otpKey: string;
}

export function UserPreDataFromJSON(json: any): UserPreData {
    return UserPreDataFromJSONTyped(json, false);
}

export function UserPreDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPreData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'otpKey': json['otpKey'],
    };
}

export function UserPreDataToJSON(value?: UserPreData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'otpKey': value.otpKey,
    };
}


